import React, { Component } from 'react';
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'

import { addToWishlist } from '../../actions/wishlist';
import { incrementQty, decrementQty } from '../../actions'
import { getCartInfo, removeFromCart, updateToCart } from '../../actions/cart'
import FullPageLoader from '../../components/common/fullPageLoader'
import { removeDefault, wishlistDefault, shopBagDefault } from '../../components/common/MangoIcons'
import MobileView from '../common/mobileView'
import noImage  from '../../assets/images/noProductImg_420x420.jpg'

class cartComponent extends Component {
    constructor(props) {
        super(props)
        this.state = { matches: window.matchMedia("(max-width: 568px)").matches };
    }
    


    componentDidMount() {
        const options = {
            connection_id: this.props.connection_id,
            web_session_trans_id: this.props.web_session_trans_id,
            tenant_name : this.props.tenant_name
        }
        this.props.getCartInfo(options)
    }

    
    handleUpdateCartItem = (item, quantity, e) => {
       e.preventDefault();
        const { connection_id, web_session_trans_id, booking_store_id } = this.props
        const options = {
            connection_id,
            web_session_trans_id,
            booking_store_id,
            lot_code: item.RID_LOT_CD,
            quantity
        }
        // 
        this.props.updateToCart(options);

    }
    

    handleRemoveCartItem = (event, item) => {
        event.preventDefault();
        const { connection_id, web_session_trans_id, booking_store_id } = this.props
        const options = {
            connection_id,
            web_session_trans_id,
            booking_store_id,
            lot_code: item.RID_LOT_CD,
        }
        // 
        this.props.removeFromCart(options);

    }

    handleAddToWishlist = (event, item) => {
        event.preventDefault();
        const { connection_id, consumer_mobile_no } = this.props
        const options = { connection_id, consumer_mobile_no, lot_code: item.RID_LOT_CD }
        this.props.addToWishlist(options)

        setTimeout(() => {
            const CartOptions = {
                connection_id: this.props.connection_id,
                web_session_trans_id: this.props.web_session_trans_id,
                booking_store_id: this.props.booking_store_id,
                lot_code: item.RID_LOT_CD,
            }
            this.props.removeFromCart(CartOptions);
        }, 100);
    }

    render() {

        const { cartItems, symbol, total, loading, presentURL } = this.props;

        if (loading) return <div><FullPageLoader /></div>
        return (
            <div>
                {/*SEO Support*/}
                <Helmet>
                    <title>{this.props.customer_name} | Cart Page</title>
                </Helmet>
                {/*SEO Support End */}

                {cartItems.length > 0 ?
                    <section className="cart-section section-b-space">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12">
                                <div className="mini-title">
                                        <span>Shopping Bag</span>
                                    </div>
                                    <div className="mini-title-divider"></div>
                                    {/* Mobile Titlw Section */}
                                    <div className="mobile-title">
                                        <img src={shopBagDefault} />
                                        <span>Shopping Bag ({this.props.cartCount})</span>
                                    </div>
                                    <div className="mobile-divider"></div>
                                    {/* Mobile Titlw Section Ends*/}
                                    <div className='table-responsive'>
                                    <table className="table cart-table table-responsive-xs">
                                        <thead>
                                            <tr className="table-head">
                                                <th scope="col">image</th>
                                                <th scope="col">product name</th>
                                                <th scope="col">MRP price</th>
                                                <th scope="col">price</th>
                                                <th scope="col">quantity</th>
                                                <th scope="col">action</th>
                                                <th scope="col">total</th>
                                            </tr>
                                        </thead>
                                        {cartItems.map((item, index) => {
                                            return (
                                                <tbody key={index}>
                                                    <tr>
                                                        <td>
                                                            <Link to={`${process.env.PUBLIC_URL}/PD/${item.RID_LOT_CD}`}>
                                                                <img src={item.RID_IMAGE_FILE_NAME !== null ?  item.RID_IMAGE_FILE_NAME : noImage} className="small-image-pls" style={{height:100}}/>
                                                            </Link>
                                                        </td>
                                                        <td><Link to={`${process.env.PUBLIC_URL}/PD/${item.RID_LOT_CD}`} className="no-display-pls">{item.RID_SKU_DESC}</Link>
                                                            {/* <div className="mobile-cart-content row">
                                                                <div className="col-xs-3">
                                                                    <div className="qty-box">
                                                                        <div className="input-group">
                                                                            <input type="text" name="quantity"
                                                                                className="form-control input-number" defaultValue={item.RID_QTY} readOnly />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-xs-3">
                                                                    <h2 className="td-color">{symbol}{item.RID_PRICE}</h2>
                                                                </div>
                                                                <div className="col-xs-3">
                                                                    <h2 className="td-color">
                                                                        <a className="btn btn-solid" onClick={(event) => this.handleAddToWishlist(event, item)} style={{ padding: "0px 4px", marginTop: 10 }}>
                                                                            <i className="fa fa-heart"></i>
                                                                            To wishlist
                                                                        </a>
                                                                    </h2>
                                                                </div>
                                                                <div className="col-xs-3">
                                                                    <h2 className="td-color">
                                                                        <a href="#" className="btn btn-solid" onClick={(event) => this.handleRemoveCartItem(event, item)} style={{ padding: "0px 4px", marginTop: 10 }}>
                                                                            <i className="icon-close"></i>
                                                                            Remove Item
                                                                        </a>
                                                                    </h2>
                                                                </div>
                                                            </div> */}
                                                            <MobileView
                                                                view={'cart'}
                                                                data={item}
                                                                presentURL={presentURL}
                                                                functions={{
                                                                    removeBag: this.handleRemoveCartItem,
                                                                    moveToWish: this.handleAddToWishlist,
                                                                    updateCartItem: this.handleUpdateCartItem
                                                                }}
                                                            />
                                                        </td>
                                                        {
                                                            !this.state.matches && 
                                                        
                                                        <td><h5 className="td-color">{symbol}{item.RID_PRICE}</h5></td>
                                                        }
                                                        <td><h5 className="td-color">{symbol}{item.RID_PRICE_DISC_AMT}</h5></td>
                                                        <td>
                                                            <div className="qty-box" 
                                                            // style={{width:'max-content'}}
                                                            >
                                                                <div className="input-group">
                                                                    <span className="input-group-prepend">
                                                                        <button type="button" className="btn quantity-left-minus" onClick={(e) => this.handleUpdateCartItem(item, parseInt(item.RID_QTY) - 1 , e )} >
                                                                            <i className="fa fa-angle-left"></i>
                                                                        </button>
                                                                    </span>
                                                                    <input disabled type="text" name="quantity" value={item.RID_QTY} readOnly={true} className="form-control input-number" />

                                                                    <span className="input-group-prepend">
                                                                        <button className="btn quantity-right-plus" onClick={(e) => this.handleUpdateCartItem(item, parseInt(item.RID_QTY) + 1 , e)} disabled={(item.qty >= item.stock) ? true : false}>
                                                                            <i className="fa fa-angle-right"></i>
                                                                        </button>
                                                                    </span>
                                                                </div>
                                                            </div>{(item.qty >= item.stock) ? 'out of Stock' : ''}
                                                        </td>
                                                        <td>
                                                           

                                                            <a href="#" className="icon" title="Remove item" onClick={(event) => this.handleRemoveCartItem(event, item)}>
                                                                {/* <i className="fa fa-times"></i> */}
                                                                <img src={removeDefault} className="icon-hovers" width={30} height={30} />
                                                            </a>
                                                        </td>
                                                        <td><h5 className="td-color">{symbol}{item.RID_NET_AMT}</h5></td>
                                                    </tr>
                                                </tbody>)
                                        })}
                                    </table>
                                    </div>
                                    
                                    <table className="table cart-table ">
                                        <tfoot>
                                            <tr>
                                                <td  style={{width: '50%',textAlignLast:'left',paddingLeft:0}}>total price :</td>
                                                <td  style={{textAlignLast:'right',paddingRight:0}}><h5>Rs. {total} </h5></td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                   
                                </div>
                            </div>
                            <div className="row cart-buttons" style={{paddingBottom:50}}>
                                <div className="col-6">
                                    {/* <Link to={`${process.env.PUBLIC_URL}/`} className="btn btn-solid">continue shopping</Link> */}
                                    <button className="btn btn-solid" onClick={() => this.props.history.push(`/csa-search`)}>continue shopping</button>
                                </div>
                                <div className="col-6">
                                    <Link to={`${process.env.PUBLIC_URL}/checkout`} className="btn btn-solid">check out</Link>
                                </div>
                            </div>
                        </div>
                    </section>
                    :
                    <section className="cart-section section-b-space">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div >
                                        <div className="col-sm-12 empty-cart-cls text-center">
                                            <img src={shopBagDefault} alt="Shopping Bag" width={50} height={50} />
                                            <h5>
                                                <strong>Your shopping bag is empty.</strong>
                                            </h5>
                                            <h5>Check all your favorite items here and place order.</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                }
            </div>
        )
    }
}
const mapStateToProps = (state) => ({
    loading: state.cart.loading,
    cartItems: state.cart.cartItems,
    cartCount: state.cart.cartItemsCount,
    symbol: state.data.symbol,
    total: state.cart.cartTotal,
    connection_id: state.tenant.connection_id,
    web_session_trans_id: state.user.web_session_trans_id,
    booking_store_id: state.store.selectedStore && state.store.selectedStore.ASM_ASSOC_CD,
    consumer_mobile_no: state.user.user_details && state.user.user_details.COM_CONSUMER_MOBILE_NO,
    customer_name: state.tenant.tenant_details.STE_ECOM_BRAND_NAME || "",
    presentURL: state.tenant.presentURL,
    tenant_name : state.tenant.store_details && state.tenant.store_details.tenant_name
})

export default connect(
    mapStateToProps,
    { removeFromCart, incrementQty, decrementQty, getCartInfo, addToWishlist, updateToCart }
)(withRouter(cartComponent))